import { generatedAPI } from './endpoints.gen';

export const secretAPIv1beta1 = generatedAPI.enhanceEndpoints({});
